export const MAX_AI_GAMES = 15;

export interface IAIList {
    aiEngine: string;
    aiGameTypesArray: number[];
}

export default interface IAiListService {
    getAIList(maxGames?: number, shouldFilterByRecentlyPlayed?: boolean, numberOfRecentlyPlayedGameToFilterOut?: number): Promise<IAIList>;
    getAINewGamesList(maxGames?: number, shouldFilterByRecentlyPlayed?: boolean, numberOfRecentlyPlayedGameToFilterOut?: number): Promise<IAIList>;
    sortGames(gameTypes: number[]): Promise<number[]>;
    getTrendingRecommendedGamesForPlayer(listTypeId?): Promise<{[key:number] : number[]}>
    getGameRecommendations(): Promise<IAIGameRecommendations>;
    clearGamesRecommendationsCache(): void;
}

export enum AI_ENGINE_TYPE {
  ML888 = "ML888"
}


export interface IAIGameRecommendations {
  engine: string;
  gameTypes: number[];
  gameTypesOrderDict: { [key: number]: number };
}

export interface IAIGameRecommendationsForPlayerByListType {
    [key:number] : number[]
}